import { Price } from "@/components/price/price.component";
import { RichText } from "@/components/richText/richText.component";
import { Text } from "@/components/text/text.component";

import type { ProductCardProduct } from "./productCard.component";

export function ProductCardContent({ product }: ProductCardContentProps) {
  return (
    <div className="flex min-w-0 flex-col gap-4">
      <Text
        variant="h5"
        component="h4"
        className="wrap-break-words text-greyscale-headline">
        {product.name}
      </Text>
      {product.shortDescription && (
        <Text
          variant="body1"
          component="p"
          className="text-greyscale-body wrap-break-words line-clamp-3">
          {product.shortDescription}
        </Text>
      )}
      <div className="flex flex-col gap-1">
        <Price
          value={product.listPrice}
          primary
          className="text-greyscale-headline shrink-0 text-2xl font-bold"
        />
      </div>

      {/* Show legal text if it exists */}
      {(product.legal || product.additionalLegal) && (
        <div className="text-greyscale-body text-xs">
          {product.legal ? <RichText>{product.legal}</RichText> : null}
          {product.additionalLegal ? (
            <RichText>{product.additionalLegal}</RichText>
          ) : null}
        </div>
      )}
    </div>
  );
}

export type ProductCardContentProps = {
  product: ProductCardProduct;
};
